module.exports = __webpack_public_path__ + "assets/images/nav-logout.b25b1365217fb2e5b8fb83e1a3d3b946.svg";